var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.icon),expression:"!!icon"}],staticClass:"mr-2",attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('a',{attrs:{"href":_vm.readableUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }